import React, {useEffect, useState} from 'react';
import {
    differenceInDays,
    differenceInHours,
    differenceInMinutes,
    differenceInMonths,
    differenceInYears
} from 'date-fns';

const TimeAgoCompact = ({timestamp, cssName, includeAgo = false}) => {
    const [timeAgo, setTimeAgo] = useState(getCompactTimeAgo(new Date(timestamp), includeAgo));

    useEffect(() => {
        const intervalId = setInterval(() => {
            setTimeAgo(getCompactTimeAgo(new Date(timestamp), includeAgo));
        }, 10000);

        return () => clearInterval(intervalId); // Cleanup interval
    }, [timestamp, includeAgo]);

    return <span
        data-tooltip-id="main-tooltip"
        data-tooltip-content={new Date(timestamp).toLocaleString()}
        className={cssName}
    >
        {timeAgo}
        {includeAgo && <span className="ago-text"> ago</span>}
    </span>;
};

// Helper function to get compact time ago
const getCompactTimeAgo = (date, includeAgo) => {
    const now = new Date();

    const years = differenceInYears(now, date);
    if (years > 0) return includeAgo ? `${years} year${years > 1 ? 's' : ''}` : `${years}y`;

    const months = differenceInMonths(now, date);
    if (months > 0) return includeAgo ? `${months} month${months > 1 ? 's' : ''}` : `${months}mo`;

    const days = differenceInDays(now, date);
    if (days > 0) return includeAgo ? `${days} day${days > 1 ? 's' : ''}` : `${days}d`;

    const hours = differenceInHours(now, date);
    if (hours > 0) return includeAgo ? `${hours} hour${hours > 1 ? 's' : ''}` : `${hours}h`;

    const minutes = differenceInMinutes(now, date);
    return includeAgo ? `${minutes} minute${minutes > 1 ? 's' : ''}` : `${minutes}m`;
};

export default TimeAgoCompact;